import styled, {css} from 'styled-components'

export const StyledFormSection = styled.div<{$fullWidth?: boolean}>(
    ({theme: {spacing}, $fullWidth}) => css`
        display: grid;
        grid-template-columns: 352px 1fr;
        margin-bottom: ${spacing * 4}px;
        width: ${$fullWidth ? '100%' : 'auto'};
    `
)
